import React from "react";
import Card from "../Card/Card";
import { useNavigate } from "react-router-dom";
import "./Secoes.css";

function SecaoManual({ titulo, ids, projetos, handleCardClick }) {
  const navigate = useNavigate();

  const onCardClick = handleCardClick || ((id) => navigate(`/projeto/${id}`));

  const projetosSelecionados = projetos.filter((p) => ids.includes(p.id));

  return (
    <section className="secao-manual">
      <h2>{titulo}</h2>
      <div className="cards-container" style={{ display: "flex", gap: 12, overflowX: "auto", scrollBehavior: "smooth" }}>
        {projetosSelecionados.map((projeto) => (
          <Card key={projeto.id} projeto={projeto} onClick={onCardClick} />
        ))}
      </div>
    </section>
  );
}

export default SecaoManual;
